import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';
import { Contract } from '@/types/ContractType';

const GoverningLaw = ({ contract }: { contract: Contract }) => {
  // Priority: product address > agentSellerInfo > fallback
  const propertyState =
    contract?.product?.address?.state ||
    contract?.agentSellerInfo?.propertyState ||
    'N/A';

  return (
    <View style={styles.section}>
      <Text style={styles.title}>
        Governing Law, Venue and Personal Jurisdiction
      </Text>
      <View style={styles.list}>
        <Text style={styles.listItem}>
          1.The validity and construction of this Agreement, and the rights and
          duties of the parties, will be governed in accordance with the laws of{' '}
          {propertyState}.
        </Text>
        <Text style={styles.listItem}>
          2.The parties agree that any dispute, controversy or claim arising
          under or in connection with this Agreement or its performance by
          either party submitted to a court shall be filed exclusively by and in
          the state or federal courts sitting in {propertyState}.
        </Text>
      </View>
    </View>
  );
};

export default GoverningLaw;
